import {takeEvery} from 'redux-saga/effects'
import {
  GENERATE_EXAM_REPORT_CARDS,
  GET_REPORT_CARD_GENERATION_PROGRESS,
  GET_REPORT_CARD_GENERATION_SLOTS,
  REGENERATE_REPORT_CARDS,
} from 'setup/redux/Actions/Generation/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GENERATE_EXAM_REPORT_CARDS, fetchData)
  yield takeEvery(GET_REPORT_CARD_GENERATION_PROGRESS, fetchData)
  yield takeEvery(GET_REPORT_CARD_GENERATION_SLOTS, fetchData)
  yield takeEvery(REGENERATE_REPORT_CARDS, fetchData)
}

export default dataSaga
